export function FormLabel({ title }) {
  return (
    <div className="mb-2">
      <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
        {title}
      </label>
      <div className="h-0.5 w-12 bg-[#0077FF] rounded-full mt-1"></div>
    </div>
  );
}